import { render, staticRenderFns } from "./IconNavDrawer.vue?vue&type=template&id=2325b8c3"
import script from "./IconNavDrawer.vue?vue&type=script&lang=js"
export * from "./IconNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./IconNavDrawer.vue?vue&type=style&index=0&id=2325b8c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports